export interface Movie {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  genres: string[];
  region: string;
  year: number;
  rating: number;
  cover: string;
  synopsis: string;
  director: string;
  cast: string[];
  heat: number;
  releaseDate: string;
}

export const movies: Movie[] = [
  {
    id: 'deep-sea-echo',
    title: '深海回声',
    type: 'movie',
    genres: ['科幻', '悬疑'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20deep%20sea%20submersible%20surrounded%20by%20bioluminescent%20darkness%2C%20mysterious%20glowing%20sonar%20rings%2C%20cold%20teal%20blue%20tones%2C%20dramatic%20moody%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-deep-sea-echo&orientation=portrait',
    synopsis:
      '一支深海科考队在万米海沟深处接收到一段来历不明的声波信号。随着声源逐渐逼近，队员们发现这段“回声”似乎来自各自尘封的记忆深处，而真相远比深海更加幽暗。',
    director: '陈亦航',
    cast: ['林深', '苏晚', '周乐言'],
    heat: 98,
    releaseDate: '2024-11-08',
  },
  {
    id: 'midnight-train',
    title: '午夜列车',
    type: 'movie',
    genres: ['惊悚', '悬疑'],
    region: '美国',
    year: 2023,
    rating: 7.9,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20lone%20vintage%20train%20on%20foggy%20night%20tracks%2C%20faint%20amber%20carriage%20lights%2C%20eerie%20mist%2C%20moody%20suspense%20atmosphere%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-midnight-train&orientation=portrait',
    synopsis:
      '一趟末班列车驶入没有站名的黑暗隧道，乘客们逐一消失，唯一的线索是车厢广播里那句始终无人回应的报站声。',
    director: 'Daniel Cole',
    cast: ['Emma Hale', 'Marcus Reed', 'Nina Park'],
    heat: 92,
    releaseDate: '2023-09-15',
  },
  {
    id: 'changan-dream',
    title: '长安旧梦',
    type: 'movie',
    genres: ['古装', '历史'],
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20ancient%20Chinese%20Tang%20dynasty%20palace%20under%20golden%20dusk%20light%2C%20lone%20painter%20with%20scroll%2C%20ornate%20architecture%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-changan-dream&orientation=portrait',
    synopsis:
      '大唐盛世落幕前的最后一夜，一位失意的画师受命绘制宫城长卷，却在笔墨之间卷入了一场关乎王朝命运的密谋。',
    director: '顾清和',
    cast: ['沈书白', '柳映秋', '裴云舟'],
    heat: 95,
    releaseDate: '2024-07-20',
  },
  {
    id: 'flashpoint',
    title: '燃点',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '中国香港',
    year: 2023,
    rating: 8.1,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20neon-lit%20Hong%20Kong%20street%20at%20night%2C%20silhouette%20of%20undercover%20cop%20in%20rain%2C%20orange%20sparks%2C%20tense%20action%20atmosphere%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-flashpoint&orientation=portrait',
    synopsis:
      '卧底警员潜伏三年，终于逼近犯罪集团核心，却在最后一次交易中被最信任的兄弟识破身份，一场生死追逐就此点燃。',
    director: '麦家辉',
    cast: ['郑天佑', '何芷晴', '雷志刚'],
    heat: 90,
    releaseDate: '2023-12-01',
  },
  {
    id: 'city-lights',
    title: '城市之光',
    type: 'movie',
    genres: ['剧情', '爱情'],
    region: '中国大陆',
    year: 2022,
    rating: 7.6,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20convenience%20store%20glow%20at%20night%20in%20modern%20city%2C%20two%20distant%20silhouettes%2C%20soft%20warm%20lights%2C%20quiet%20romance%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-city-lights&orientation=portrait',
    synopsis:
      '两个在都市里各自奔波的陌生人，因深夜便利店的一盏灯反复相遇，在钢筋森林中慢慢照亮彼此的孤独。',
    director: '许知远',
    cast: ['江屿', '温言', '宋歌'],
    heat: 78,
    releaseDate: '2022-05-19',
  },
  {
    id: 'above-dunes',
    title: '沙丘之上',
    type: 'movie',
    genres: ['冒险', '科幻'],
    region: '美国',
    year: 2024,
    rating: 8.3,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20vast%20desert%20dunes%20under%20a%20violet%20dusk%20sky%2C%20explorers%20walking%20on%20ridge%2C%20dramatic%20sci-fi%20scale%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-above-dunes&orientation=portrait',
    synopsis:
      '沙漠尽头的绿洲传说被世代传唱。一支年轻的勘探队穿越死亡沙海，只为寻找那颗能改变命运的蓝色矿石。',
    director: 'Peter Nash',
    cast: ['Owen Blake', 'Sara Lund', 'Diego Marsh'],
    heat: 93,
    releaseDate: '2024-03-30',
  },
  {
    id: 'silent-testimony',
    title: '无声证词',
    type: 'movie',
    genres: ['悬疑', '犯罪'],
    region: '韩国',
    year: 2023,
    rating: 8.0,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20solitary%20figure%20in%20dim%20interrogation%20room%2C%20single%20harsh%20lamp%2C%20cold%20grey%20tones%2C%20tense%20thriller%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-silent-testimony&orientation=portrait',
    synopsis:
      '一桩没有目击者的旧案重启，唯一的证人是失聪的清洁工，她用十六年的沉默记下了真相的每一个细节。',
    director: '朴振宇',
    cast: ['韩志勋', '徐恩静', '李东旭'],
    heat: 85,
    releaseDate: '2023-10-06',
  },
  {
    id: 'spring-confession',
    title: '春日告白',
    type: 'movie',
    genres: ['爱情', '青春'],
    region: '日本',
    year: 2022,
    rating: 7.4,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20sunlit%20Japanese%20high%20school%20library%20with%20cherry%20blossoms%20outside%2C%20single%20letter%20on%20desk%2C%20soft%20pastel%20tones%2C%20nostalgic%20romance%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-spring-confession&orientation=portrait',
    synopsis:
      '高中最后一个春天，转学生把一封没有寄出的信夹进了图书馆的诗集里，而收信人直到十年后才读懂。',
    director: '佐藤悠真',
    cast: ['山田飒', '铃木遥', '中村翔'],
    heat: 70,
    releaseDate: '2022-04-02',
  },
  {
    id: 'wind-chaser',
    title: '追风者',
    type: 'movie',
    genres: ['运动', '励志'],
    region: '中国大陆',
    year: 2024,
    rating: 7.8,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20young%20sprinter%20exploding%20off%20starting%20blocks%20on%20track%2C%20dynamic%20motion%20blur%2C%20warm%20golden%20sunlight%2C%20inspiring%20sports%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-wind-chaser&orientation=portrait',
    synopsis:
      '被伤病击垮的短跑少年在退役教练的坚持下重返赛道，用最后一年时间追逐那个被所有人放弃的奥运梦。',
    director: '罗启帆',
    cast: ['陆野', '程星', '姜宁'],
    heat: 76,
    releaseDate: '2024-08-16',
  },
  {
    id: 'undercurrent',
    title: '暗涌',
    type: 'movie',
    genres: ['剧情', '悬疑'],
    region: '中国大陆',
    year: 2021,
    rating: 7.5,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20rainy%20seaside%20town%20at%20dusk%2C%20stormy%20grey%20ocean%2C%20lone%20figure%20with%20umbrella%2C%20ominous%20mystery%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-undercurrent&orientation=portrait',
    synopsis:
      '平静的海滨小镇下了整月的雨，一具浮尸让所有人开始怀疑：那些看似寻常的邻居，究竟藏着多少秘密。',
    director: '孟繁',
    cast: ['陈默', '许清', '顾媛'],
    heat: 66,
    releaseDate: '2021-11-12',
  },
  {
    id: 'city-of-mist',
    title: '迷雾之城',
    type: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '中国大陆',
    year: 2024,
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20city%20skyline%20swallowed%20by%20thick%20fog%2C%20lone%20detective%20silhouette%20with%20flashlight%2C%20cold%20blue%20grey%20tones%2C%20mystery%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-city-of-mist&orientation=portrait',
    synopsis:
      '一场百年不遇的大雾笼罩整座城市。刑警队长在追查连环案时发现，所有线索都指向十年前那起被她亲手结案的冤案。全剧共 24 集。',
    director: '韩沐',
    cast: ['白亦寒', '叶清歌', '吴铭'],
    heat: 97,
    releaseDate: '2024-06-10',
  },
  {
    id: 'chronicles-rivers',
    title: '山河故人志',
    type: 'tv',
    genres: ['历史', '古装'],
    region: '中国大陆',
    year: 2023,
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20three%20warriors%20on%20ancient%20battlefield%20at%20dawn%2C%20tattered%20banners%2C%20epic%20historical%20scale%2C%20warm%20amber%20and%20ink%20tones%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-chronicles-rivers&orientation=portrait',
    synopsis:
      '乱世之中，三个出身迥异的年轻人因一纸征兵令走到一起，在山河破碎的年代写下各自的传奇与取舍。全剧共 36 集。',
    director: '沈砚',
    cast: ['萧珩', '沈昭', '云清'],
    heat: 88,
    releaseDate: '2023-08-25',
  },
  {
    id: 'heartbeat-frequency',
    title: '心跳频率',
    type: 'tv',
    genres: ['都市', '爱情'],
    region: '韩国',
    year: 2024,
    rating: 7.7,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20radio%20studio%20at%20midnight%20with%20soft%20glowing%20mic%2C%20city%20lights%20through%20window%2C%20romantic%20blue%20night%20tones%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-heartbeat-frequency&orientation=portrait',
    synopsis:
      '心内科住院医与电台深夜主持人隔着一通打错的电话相识，在无数个凌晨交换心事，却始终不敢见面。全剧共 16 集。',
    director: '金秀贤',
    cast: ['李在民', '韩彩英', '朴叙俊'],
    heat: 82,
    releaseDate: '2024-02-14',
  },
  {
    id: 'operation-daybreak',
    title: '破晓行动',
    type: 'tv',
    genres: ['谍战', '动作'],
    region: '中国大陆',
    year: 2023,
    rating: 8.2,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%201940s%20Shanghai%20alley%20at%20dawn%2C%20spy%20in%20trench%20coat%2C%20vintage%20cars%2C%20sepia%20and%20teal%20tones%2C%20tense%20espionage%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-operation-daybreak&orientation=portrait',
    synopsis:
      '1943 年的上海，一份足以改变战局的名单在黑市流转，潜伏者必须在黎明到来前完成近乎不可能的任务。全剧共 30 集。',
    director: '程远',
    cast: ['顾承', '宋黎', '周牧'],
    heat: 84,
    releaseDate: '2023-04-18',
  },
  {
    id: 'star-river-academy',
    title: '星河学院',
    type: 'tv',
    genres: ['奇幻', '青春'],
    region: '中国大陆',
    year: 2024,
    rating: 7.9,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20magical%20academy%20floating%20above%20clouds%20with%20glowing%20constellations%2C%20young%20students%2C%20deep%20teal%20blue%20night%20sky%2C%20fantasy%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-star-river-academy&orientation=portrait',
    synopsis:
      '在一所专为超能力少年开设的秘密学院里，新生们要一边学着控制自己的天赋，一边揭开学院地下的百年谜题。全剧共 20 集。',
    director: '夏橙',
    cast: ['林星野', '苏明', '秦渺'],
    heat: 80,
    releaseDate: '2024-09-01',
  },
  {
    id: 'everyday-life',
    title: '人间烟火',
    type: 'tv',
    genres: ['家庭', '都市'],
    region: '中国大陆',
    year: 2022,
    rating: 8.0,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20cozy%20noodle%20shop%20in%20old%20Chinese%20neighborhood%2C%20warm%20lantern%20light%2C%20family%20around%20table%2C%20tender%20documentary%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-everyday-life&orientation=portrait',
    synopsis:
      '城中村一间小面馆的日常，记录了一家三代人在拆迁、升学与离别中的悲欢，平凡日子里藏着最动人的温度。全剧共 32 集。',
    director: '田禾',
    cast: ['老陈', '陈姨', '小满'],
    heat: 72,
    releaseDate: '2022-06-30',
  },
  {
    id: 'crime-files',
    title: '猎罪档案',
    type: 'tv',
    genres: ['刑侦', '悬疑'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20detective%20team%20examining%20case%20files%20under%20cold%20light%2C%20evidence%20board%2C%20tense%20crime%20drama%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-crime-files&orientation=portrait',
    synopsis:
      '一支由心理侧写师与老刑警组成的小队，专门追查那些被时间掩埋的悬案。每翻开一页档案，就揭开一个人性的深渊。全剧共 28 集。',
    director: '关山',
    cast: ['陆霆', '纪云', '方然'],
    heat: 91,
    releaseDate: '2024-05-22',
  },
  {
    id: 'the-way-home',
    title: '归途',
    type: 'tv',
    genres: ['剧情', '家庭'],
    region: '英国',
    year: 2021,
    rating: 7.8,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20lone%20cyclist%20on%20winding%20country%20road%20at%20golden%20hour%2C%20rolling%20green%20hills%2C%20nostalgic%20drama%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-the-way-home&orientation=portrait',
    synopsis:
      '一位退休的老水手决定骑车穿越整个国家，只为回到阔别四十年的故乡，一路上遇见的每个人都在讲述自己的归途。全剧共 12 集。',
    director: 'James Whitmore',
    cast: ['Arthur Gill', 'Rose Bell', 'Tom Hardy'],
    heat: 64,
    releaseDate: '2021-09-09',
  },
];

export interface HeroSlide {
  id: string;
  tagline: string;
  desc: string;
  banner: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'deep-sea-echo',
    tagline: '科幻悬疑巨制',
    desc: '万米海沟深处，一段无法解释的回声正在逼近。',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20deep%20sea%20submersible%20descending%20into%20glowing%20abyss%2C%20bioluminescent%20creatures%2C%20cold%20teal%20blue%20light%2C%20epic%20sci-fi%20scale%2C%20moody%20atmospheric%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-deep-sea-echo&orientation=landscape',
  },
  {
    id: 'city-of-mist',
    tagline: '年度高分剧集',
    desc: '大雾笼罩的城市里，旧案的真相正一点点浮出水面。',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20foggy%20city%20avenue%20at%20night%2C%20silhouette%20of%20detective%20walking%20under%20streetlamps%2C%20cold%20blue%20grey%20palette%2C%20cinematic%20mystery%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-city-of-mist&orientation=landscape',
  },
  {
    id: 'flashpoint',
    tagline: '燃爆动作新片',
    desc: '霓虹雨夜里，卧底的最后一夜注定无人可退。',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20rain-soaked%20Hong%20Kong%20night%20street%20with%20neon%20reflections%2C%20undercover%20cop%20running%2C%20orange%20and%20teal%20cinematic%20palette%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-flashpoint&orientation=landscape',
  },
];

export const genreOptions = ['全部', '爱情', '动作', '悬疑', '科幻', '犯罪', '古装', '历史', '剧情', '青春', '家庭', '奇幻', '都市', '谍战', '运动', '惊悚', '冒险'];
export const regionOptions = ['全部', '中国大陆', '美国', '韩国', '日本', '中国香港', '英国'];
export const yearOptions = ['全部', '2024', '2023', '2022', '2021'];